import React, { Suspense, useEffect } from 'react';

import { IApplicationPage } from 'application/pages/types';
import PAGES_CONST from 'application/pages/constants';
import { RouterUtils, matchPath, useNavigate, useLocation } from 'application/providers/RouterProvider';
import { LocalAccessRoles } from 'application/providers/AuthProvider';
import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

export const POINTS_GROUPS_PATH = '/points-groups/:id';
export const POINTS_GROUPS_MENU_PATH = '/points-groups/all';

export enum IdParamValues {
  ALL = 'all',
}

export type PointsGroupsPageParamsType = {
  id?: string | IdParamValues;
};

const Renderer = React.lazy(() => import('./renderer'));

const PointsGroupsPageWrapper: IApplicationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isNeedRedirect = !matchPath({ path: POINTS_GROUPS_PATH, end: false }, location.pathname);

  useEffect(() => {
    if (isNeedRedirect) {
      navigate(RouterUtils.generatePath(POINTS_GROUPS_PATH, { id: IdParamValues.ALL }), { replace: true });
    }
  }, [isNeedRedirect]);

  return (
    <Suspense fallback={<LoadingScreen delay={PAGES_CONST.LOADER_SCREEN_DELAY} />}>
      {!isNeedRedirect && <Renderer />}
    </Suspense>
  );
};

PointsGroupsPageWrapper.config = {
  routes: [
    {
      path: POINTS_GROUPS_PATH,
    },
  ],
  access: [LocalAccessRoles.AUTHORIZED],
};

export default PointsGroupsPageWrapper;
